// extracted by mini-css-extract-plugin
export default {"base__bg":"Base_base__bg__aeZr+","container":"Base_container__MrHuz","wrapper":"Base_wrapper__pQypb"};